'use strict';

const Reply = require('./reply.js');

function ReplyList (id) {
  this.tpl = {
    list: '[data-template="community-replies"]',
    items: '[data-template="community-replies-items"]'
  };

  this.refs = {
    list: '[data-ref="community-replies-' + id + '"]',
    items: '[data-ref="community-replies-items-' + id + '"]'
  };

  this.id = id;
  this.html;
}

ReplyList.prototype.buildHTML = function () {
  var html = document.querySelector(this.tpl.list).cloneNode(true);
  html.setAttribute(
    'data-ref',
    html.getAttribute('data-template') + '-' + this.id
  );
  html.removeAttribute('data-template');

  var items = html.querySelector(this.tpl.items);
  items.setAttribute(
    'data-ref',
    items.getAttribute('data-template') + '-' + this.id
  );
  items.removeAttribute('data-template');

  return html;
};

ReplyList.prototype.getHTML = function () {
  if (!this.html) this.html = this.buildHTML();
  return this.html;
};

ReplyList.prototype.appendReply = function (data) {
  var reply = new Reply(data);
  var items = this.getHTML().querySelector(this.refs.items);
  return items.appendChild(reply.getHTML());
};

ReplyList.prototype.appendReplies = function (root) {
  if (!root.querySelector(this.refs.list)) {
    root.appendChild(this.getHTML());
  }
};

module.exports = ReplyList;



//////////////////
// WEBPACK FOOTER
// ./_js/comments/reply-list.js
// module id = 33
// module chunks = 0